module.exports = __webpack_public_path__ + "static/media/hiw4yellow.d513d8b6.svg";